import React, { Component } from 'react'
import { Link, withRouter } from "react-router-dom";

import CustomModal from "../Bar/CustomModal";
import Pagination from "../Bar/Pagination";
import API from '../../config/api';
import { ToastContainer, toast } from "react-toastify";
import moment from 'moment';
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";



export class CategoryIndex extends Component {

  constructor(props) {
    super(props)
    
    this.getAllCategories = this.getAllCategories.bind(this);
    this.state = {
      data: null,
      page: 1,
      total: 0,
      categories: [],
      image_url: "",
      excelData: [],
    }
  }

  componentDidMount() {
    // this.getParam("success");
    // toast.success("Your action is successful", {
    //   data: {
    //     title: "Success toast",
    //     text: "This is a success message",
    //   },
    // })
  }

  UNSAFE_componentWillMount() {
    this.getAllCategories();
    this.getImageLink();
  }

  getImageLink() {
    let url = API.getImage();
    this.state.image_url = url
    this.setState({})
  }

  getParam(name) {
    
    let success = window.location.search.split(`${name}=`)[1]
    if(success){
      toast.success("Your action is successful", {
        data: {
          title: "Success toast",
          text: "This is a success message",
        },
      })
   }
  }

  getAllCategories = async () => {
    try {
      let query = `page=${this.state.page}`
      let results = await API.getAllCategory(query);
      let data = results.data;
      
      this.setState({ categories : data.category, total: data.total });

    } catch (error) {
      console.log(error)
    }
  }

  onSearch = async (event) => {
    event.preventDefault();
    let value = event.target.value;
    try {
      let query = `page=${this.state.page} + &&s=${value}`
      let results = await API.getAllCategory(query);
      
      let data = results.data;
      
      this.setState({ categories : data.category, total: data.total });

    } catch (error) {
      console.log(error)
    }
  }

  handleFileUpload = async (event) => {
    // event.preventDefault();
    let dataExcel = [];
    const file = event.target.files[0];
    if (!file)
      return ;
    const reader = new FileReader();

    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Assuming the first sheet is the one you want
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      const filteredData = jsonData.slice(1);

      // jsonData.map((json, indexs) => {
      //   if(json[1] == 2022) {
      //     json[2] = 2023;
      //   }

      // })

      let file_data = [];

      filteredData.forEach((data, index) => {
        if (index != 0) ;
          file_data.push({
            name: data[0],
            score: data[1]
          }) 
      });

      try {
        let results = await API.postOneCategory(file_data);
        
        if (results.result === 1){
          toast.success("Your action is successful", {
            data: {
              title: "Success toast",
              text: "This is a success message",
            },
          })
          this.setState({ success: results.result })
          this.getAllCategories();
        }
  
      } catch (error) {
        console.log(error)
      }


      this.setState({ excelData: jsonData }); // Set the state with the Excel data
    };

    reader.readAsArrayBuffer(file);
  }

  onPaginationPress = (page) => {
    this.state.page = page;
    // this.setState({ page : page})
    this.getAllCategories();
    this.setState({})
  }

  delete = (id) => {
    console.log(id)
  }

  linkToNewPage= async (id) => {
    let element = document.getElementById(`clickview${id}`);
    element.click();
  }

  render() {
    return (
      <div className="col-12 ">
        <ToastContainer />
          <div className="card card-body card-hover-shadow p-40">
            <h4 className="card-title"><strong>Total Categories: <b className="text-success fw-500 w-80px"> {this.state.total.toLocaleString('en-US')}</b> <span class="fa fa-tasks"></span></strong></h4>

            <div className="card-body">

            <div className="flexbox mb-20">
                <div className="">
                {/* <div className="lookup"> */}
                  {/* <input className="w-200px" type="text" name="s" placeholder="Search" onChange={this.onSearch} /> */}
                </div>

                <div className="btn-toolbar">
                  <div className="btn-group btn-group-sm">
                    {/* <button className="btn" title="Refresh" data-provide="tooltip"><i class="ion-refresh"></i>  </button> */}
                    {/* <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i></button> */}
                    <Link to="/categorynew" > <button className="btn btn-primary" title="Add new" data-provide="tooltip"> <i className="ion-plus-round"></i></button></Link>
                    {/* <Link to="/user/new" > <button className="btn" title="Add new" data-provide="tooltip"><i class="ion-plus-round"></i>New</button></Link> */}
                  </div>

                  <div className="btn-group btn-group-sm ml-2 d-none d-sm-flex">
                    {/* <button className="btn dropdown-toggle btn-info" data-toggle="dropdown">Import</button> */}
                    <button className="btn btn-info" onClick={(e) => {
                        e.preventDefault()
                        document.getElementById("importExcel").click()
                        }}><i class="fa fa-file-excel-o"></i> Import</button>
                    <div className="dropdown-menu dropdown-menu-right">
                      <input
                        type="file"
                        accept=".xlsx, .xls"
                        onChange={this.handleFileUpload}
                        hidden
                        id="importExcel"
                      />
                      {/* <Link className="dropdown-item" onClick={(e) => {
                        e.preventDefault()
                        document.getElementById("importExcel").click()
                        }}><i class="fa fa-file-excel-o"></i> Excel</Link> */}
                        
                      {/* <a className="dropdown-item" href="/">SQL</a>
                      <a className="dropdown-item" href="/">PDF</a>
                      <a className="dropdown-item" href="/">Text</a> */}
                    </div>
                  </div>
                </div>
              </div>
            <div>
          </div>

              <table className="table table-hover table-has-action">
                <thead>
                  <tr>
                    <th><h6>#</h6></th>
                    {/* <th> <h6>Thumbnail</h6> </th> */}
                    <th> <h6>Name</h6> </th>
                    {/* <th> <h6>Score</h6> </th> */}
                    {/* <th> <h6>Created date</h6></th> */}
                    <th class="text-center w-100px"><h6>Actions</h6></th>
                  </tr>
                </thead>
                <tbody>
                {
                  this.state.categories
                  .map((category, index)=> {
                  return <tr>
                      <th onClick={() => this.linkToNewPage(category.id)} scope="row"><b>{( (this.state.page - 1) * 10) + (index + 1)}</b></th>
                      {/* <td><img style={{width: 30, height: 30, borderRadius: 30}} src={category.thumbnail_url} alt="video thumbnail" /></td> */}
                      {/* <td>
                        <div class="media">
                          <img class="avatar" src={category.thumbnail_url ? category.thumbnail_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                          <img class="avatar" src={category.thumbnail_url ? category.thumbnail_url : require('../../assets/assets_theme/img/avatar/1.jpg')} alt="..." />
                          <div class="media-body">
                            <p >{category.name_kh}</p>
                          </div>
                        </div>
                      </td> */}
                      <td onClick={() => this.linkToNewPage(category.id)}><strong>{category.name}</strong></td>
                      {/* <td><strong>{category.score}</strong></td> */}
                      {/* <td>{moment(category.created_at).format("DD-MMM-YYYY")}</td> */}
                      <td className="text-right table-actions">
                        <Link title='View' class="btn btn-square btn-round btn-primary" to={`/categoryedit?id=${category.id}`}><i class="fa fa-eye"></i></Link>
                        <span>&nbsp;</span><Link title='Edit' class="btn btn-square btn-round btn-info" to={`/categoryedit?id=${category.id}`}><i id={`clickview${category.id}`}  class="ti-pencil"></i></Link>
                        {/* <span>&nbsp;</span><Link title='Delete' class="btn btn-square btn-round btn-danger"><i data-toggle="modal" data-target="#modal-center" onClick={() => this.setState({data: category})} class="fa fa-trash"></i></Link> */}

                        {/* <Link className="table-action hover-primary" title="View" to={`/categoryview?id=${category.id}`}><i className="fa fa-eye"></i></Link>
                        <Link className="table-action hover-primary" title="Edit" to={`/categoryedit?id=${category.id}`}><i class="ti-pencil"></i></Link> */}
                      
                        {/* <i className="ti-trash table-action hover-danger" data-toggle="modal" data-target="#modal-center" title="Delete" onClick={() => this.setState({data: category})}></i>  */}

                        {/* <div className="dropdown table-action">
                          <span className="dropdown-toggle no-caret hover-primary" data-toggle="dropdown" title="More"><i class="ti-more-alt rotate-90"></i></span>
                          <div className="dropdown-menu dropdown-menu-right">
                            <a className="dropdown-item" href="/"><i class="ti-menu-alt"></i> Details</a>
                            <a className="dropdown-item" href="/"><i class="ti-clip"></i> Add file</a>
                            <a className="dropdown-item" href="/"><i class="ti-bar-chart"></i> Performance</a>
                          </div>
                        </div> */}
                      </td>
                    </tr>
                  })
                }
                </tbody>
              </table>
              {/* <Pagination 
                onPaginationPress = {this.onPaginationPress}
                totalPageLength = {this.state.total}
                selectPage = {this.state.page}
              /> */}
            </div>
          </div>
          {
              this.state.data &&
              <CustomModal 
                data={ this.state.data }  
                title="Do you really want to delete this category?"
                delete = {this.delete}
              />
           }
        </div>
    )
  }
}

export default CategoryIndex;